function buildAddToCartPayload() {
    sanitizeSelectionsAgainstScenarios();
    const product_id = resolveCompositeProductId();
    const components = {};
    const accessories = [];

    const comps = (STATE.data?.components || []);

    const selections = collectSelectionsFromStateOrDOM();
    const hash = selectionHash(selections);

    comps.forEach(c => {
        const cid = String(c.id);

        if (Number(cid) === STATE.accessories_step_id) return;

        const pid = Number(STATE.selected[c.id] || 0);
        if (!pid) return;

        const payload = { product_id: pid };

        const vid = STATE.selectedVariants[c.id];
        if (vid) {
            payload.variation_id = Number(vid);

            const attrs = getSelectedVariationAttributes(c.id, pid, vid);
            if (attrs && typeof attrs === 'object') {
                payload.attributes = attrs;
            }
        }

        payload.qty = Number(STATE.selectedQty[c.id] || 1);

        components[cid] = payload;
    });

    if (STATE.selectedAccessories) {
        Object.entries(STATE.selectedAccessories).forEach(([productId, data]) => {
            accessories.push({
                product_id: Number(productId),
                qty: data.qty
            });
        });
    }

    return { product_id, components, accessories, qty: 1 };
}